import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useCaterersPanelStyles = makeStyles({
  container: {
    backgroundColor: tokens.colorBrandBackground2Hover,
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke2),
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalXS,
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
  },
  /** Figma 2026 catering callout (node `1-576`): soft tinted info chip. */
  containerFigma: {
    backgroundColor: tokens.colorBrandBackground2,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    borderRadius: '0.5rem',
  },
  icon: {
    color: tokens.colorBrandForeground2Hover,
    flexShrink: 0,
    marginTop: tokens.spacingVerticalXXS,
  },
  iconFigma: {
    color: tokens.colorBrandForeground1,
  },
  text: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
  },
  link: {
    color: tokens.colorBrandForeground2Hover,
    textDecoration: 'none',
    fontWeight: tokens.fontWeightSemibold,
    ':hover': {
      textDecoration: 'underline',
    },
  },
  linkFigma: {
    color: tokens.colorBrandStroke1,
  },
});
